<template>
  <div class="row"><h3>Dashboard</h3></div>
</template>
<script>
export default {
  name: 'starter-page',
  data() {
    return {};
  }
};
</script>
<style></style>
